<template>
  <div class="card flex justify-content-center">
    <SearchImageWrapper
      :base64data="base64data"
      @show-modal="imageSearch.isImageSearchModalOpen = true"
    />

  </div>
</template>

<script setup lang="ts">

import { computed, ref } from "vue";
import SearchImageWrapper from "@/features/search/components/drag-and-drop/SearchImageWrapper.vue";
import { useImageSearch } from "@/features/search/store";

const imageSearch = useImageSearch();
const base64data = computed(() => imageSearch.imageBase64Data);

</script>

<style scoped>

</style>
